module.exports = __webpack_public_path__ + "img/TCRB.e4be8158.png";